import React, { useEffect } from 'react'
import './Project.css'
import { projects } from '../data'
import Aos from 'aos'
import "aos/dist/aos.css"
export const Project = () => {
    useEffect(() => {
        Aos.init(({}))
    }, [])
    return (
        <div className="project" id="project">
            <p>
                PROJECTS
            </p>
            <div>
                <div data-aos="zoom-in-up" data-aos-duration="4000" className="card">
                    <h3 className="title">PROJECTS</h3>
                    <div className="bar">
                        <div className="emptybar"></div>
                        <div className="filledbar"></div>
                    </div>
                    <div className="arrow">
                        <img alt="" src="https://img.icons8.com/external-flatart-icons-solid-flatarticons/80/65f4ad/external-arrow-arrow-flatart-icons-solid-flatarticons-6.png" />
                    </div>
                    <div className="circle">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <circle className="stroke" cx="60" cy="60" r="50" />
                        </svg>
                    </div>
                </div>
                {
                    projects.map((data) => {
                        return (
                            <div data-aos="slide-left" data-aos-duration={2000} className="card" key={data.name}>
                                <h3 className="title">{data.name}</h3>
                                <div className="tags" style={{ paddingLeft: '10px' }}>
                                    {
                                        data.tech.map((tech) => (
                                            <section key={tech}>{tech}</section>
                                        ))
                                    }
                                </div>
                                <div className="bar">
                                    <div className="emptybar"></div>
                                    <div className="filledbar"></div>
                                </div>
                                <div className="card-icons">
                                    {
                                        (data.links.git !== "")
                                            ?
                                            <div className="plink" style={{ padding: '10px' }}>
                                                <a href={data.links.git} target="_blank" rel="noreferrer"><img src="https://img.icons8.com/material-outlined/30/ffffff/github.png" alt="" /></a>
                                            </div>
                                            :
                                            <></>
                                    }
                                    {
                                        (data.links.link !== "")
                                            ?
                                            <div>
                                                <section className="plink"><a href={data.links.link} target="_blank" rel="noreferrer"><img src="https://img.icons8.com/material-outlined/30/ffffff/link--v1.png" alt="" /></a></section>
                                            </div>
                                            : <></>
                                    }
                                </div>
                                <div className="_image">
                                    <img src={data.img} className="_size" alt="" height="100px"></img>
                                </div>
                                <div className="circle">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <circle className="stroke" cx="70" cy="70" r="60" />
                                    </svg>
                                </div>
                                <div className="done-on">
                                    {data.date}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
